import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { FormVariable, FormVariables } from '../../../../../../../sellions_forms/projects/forms/src/lib/interfaces/form-variables.interface';
import { ProcessWithForm } from '../../interfaces/process-with-form.interface';
import { catchError, delay, retryWhen, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ObservableWorkaround } from '../../utils/observable-workaround.class';
import { DisplayFormService } from '../form/display-form.service';
import { FormDataService } from '../../../../../../../sellions_forms/projects/forms/src/lib/services/form-data/form-data.service';

@Injectable()
export class ProcessService {
  readonly deplay_between_tries = 1000;
  readonly form_sending_retries = 3;

  processError = new BehaviorSubject('');

  constructor(private formDataService: FormDataService, private displayFormService: DisplayFormService, private httpClient: HttpClient) {}

  public getProcessWithForm(baseUrl: string, name: string): Observable<any> {
    return this.httpClient.get(baseUrl + `api/process/${name}/formDefinition`);
  }

  public initProcess(baseUrl: string, proc: ProcessWithForm): Observable<any> {
    if (proc.formJson) {
      const startProcessFn = (processVariables: FormVariables) => this.startProcess(baseUrl, proc, processVariables);
      return this.displayFormService.displayForm(baseUrl, proc.formJson, proc, startProcessFn, this.processError);
    } else {
      return this.startProcess(baseUrl, proc, null);
    }
  }

  public startProcess(baseUrl: string, process: ProcessWithForm, processVariables?: FormVariables): Observable<any> {
    this.processError.next('');

    let startProcessObservable: Observable<any>;

    if (processVariables.multipartFiles && Array.isArray(processVariables.multipartFiles) && processVariables.multipartFiles.length > 0) {
      startProcessObservable = this.startProcessWithMultipartFiles(baseUrl, process, processVariables);
    } else {
      startProcessObservable = this.startProcessWithoutMultipartFiles(baseUrl, process, processVariables.variables);
    }

    let retries = this.form_sending_retries;

    return startProcessObservable.pipe(
      retryWhen((errors) => this.handleRetries(errors, retries)),
      catchError((error) => ObservableWorkaround.throw({ error, process, variables: processVariables })),
    );
  }

  private startProcessWithoutMultipartFiles(baseUrl: string, process, variables?: Array<FormVariable>): Observable<any> {
    const variablesObject = this.formDataService.mapVariablesToVariablesObject(variables);
    return this.httpClient.post(baseUrl + `api/process/${process.key}/start`, variablesObject);
  }

  private startProcessWithMultipartFiles(baseUrl: string, process, processVariables?: FormVariables): Observable<any> {
    const formData = this.formDataService.mapVariablesToFormData(processVariables);
    return this.httpClient.post(baseUrl + `api/process/v2/${process.key}/start`, formData);
  }

  private handleRetries(errors: Observable<any>, retries: number): Observable<any> {
    return errors.pipe(
      switchMap((error) => {
        if (error.status === 0 && retries-- > 0) {
          const remainingTries = this.form_sending_retries - retries;
          const msg = `Brak połączenia z internetem. Próba przesłania formularza: ${remainingTries} z ${this.form_sending_retries}`;
          this.processError.next(msg);
          return ObservableWorkaround.of(error).pipe(delay(this.deplay_between_tries));
        }

        return ObservableWorkaround.throw(error);
      }),
    );
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/services/process/process.service.ts